import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { IFormEditorTypeActionTypes } from "../../action-types/form/IFormEditorTypeActionTypes";
import { IFormEditorTypeReducer } from "../../page-state-model/form/IFormEditorTypeReducer";
const iniState: IFormEditorTypeReducer = {
    status: ePageBaseStatus.is_not_initialization,
    formEditorTypes: []
}
export const formEditorTypeReducer = (state: IFormEditorTypeReducer = iniState, action: IFormEditorTypeActionTypes): IFormEditorTypeReducer => {
    switch (action.type) {
        case "FORM_EDITOR_TYPE_LOAD_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "FORM_EDITOR_TYPE_LOAD_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                formEditorTypes: action.payload
            }
        case "FORM_EDITOR_TYPE_LOAD_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                formEditorTypes: []
            }
        default:
            return state;
    }
}